<script>
  import PageDataSidebar from '@/components/shared_components/page_data/PageDataSidebar';

  export default {
    extends: PageDataSidebar,
    computed: {
      mobTitle() { return this.$gettext('Payout methods'); },
      navLinksList() {
        return [{
          title: this.$gettext('Payout methods'),
          route: this.userIsInterpreter ? {name: 'ServerPayoutsAll'} : ''
        }, {
          title: this.$gettext('Rates'),
          route: {name: 'ServerRates'}
        }];
      }
    }
  };
</script>
